module.exports = __webpack_public_path__ + "static/media/6H.84564e31.png";